"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_client_common_1 = require("@attraqt/http-client-common");
var uuid_1 = require("uuid");
var validateSchema_1 = __importDefault(require("./models/validateSchema"));
var Activity = /** @class */ (function () {
    function Activity() {
        this.isInitialized = false;
        this.sample = { action: '', target: {} };
        this.user = { identities: {}, segments: [], traits: {} };
    }
    Activity.prototype.initUser = function (storage) {
        if (!this.user.identities.sessionid) {
            this.user.identities.sessionid =
                storage.getItem('attraqtsessionid') || uuid_1.v4();
        }
        this.storage.setItem('attraqtsessionid', this.user.identities.sessionid);
    };
    Activity.prototype.assertIsInit = function () {
        if (!this.isInitialized) {
            throw Error('The activities module must be initialized before using methods.');
        }
    };
    Activity.prototype.init = function (options, httpClient) {
        var _a;
        if (!options || !options.trackerKey)
            throw Error('A tracker key is required to initialize the activities module.');
        var region = ((_a = options.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || Region.EU;
        this.apiUrl = "http" + (region !== Region.DEV ? 's' : '') + "://collect-" + region + ".attraqt.io/" + options.trackerKey;
        this.storage = options.storage;
        this.httpClient = httpClient;
        this.initUser(this.storage);
        this.hasOptedOut = this.storage.getItem('attraqtoptout') === 'true';
        this.isInitialized = true;
    };
    Activity.prototype.send = function (activities, options) {
        var _this = this;
        if (!this.isInitialized) {
            throw Error('The activities module must be initialized before sending activities.');
        }
        var activitiesWithUserData = [].concat(activities).map(function (act) {
            var activity = __assign(__assign({}, act), { user: act && act.user ? act.user : _this.user });
            if (!validateSchema_1.default(activity)) {
                throw new Error('The provided activity does not match the required format.');
            }
            return activity;
        });
        if (this.hasOptedOut)
            return null;
        var request = __assign({ method: http_client_common_1.Method.Post, headers: { 'Content-Type': 'application/json' }, url: this.apiUrl, body: JSON.stringify(activitiesWithUserData) }, options);
        return this.httpClient.send(request);
    };
    Activity.prototype.setUser = function (user) {
        this.assertIsInit();
        if (!user || !validateSchema_1.default(__assign(__assign({}, this.sample), { user: user }))) {
            throw new TypeError('The provided user does not match the required format.');
        }
        this.setUserIdentities(user.identities);
        this.setUserSegments(user.segments);
        this.setUserTraits(user.traits);
        this.initUser(this.storage);
    };
    Activity.prototype.addUserIdentity = function (identityRepository, identity) {
        this.assertIsInit();
        if (typeof identityRepository !== 'string' ||
            typeof identity !== 'string') {
            throw new TypeError('identityRepository and identity must be strings.');
        }
        this.user.identities[identityRepository.toLocaleLowerCase()] = identity;
        this.initUser(this.storage);
    };
    Activity.prototype.setUserIdentities = function (identities) {
        this.assertIsInit();
        if (!validateSchema_1.default(__assign(__assign({}, this.sample), { user: { identities: identities } })) ||
            Object.keys(identities).length === 0) {
            throw new TypeError('The provided identities do not match the required format.');
        }
        this.user.identities = identities;
        this.initUser(this.storage);
    };
    Activity.prototype.addUserSegment = function (segment) {
        this.assertIsInit();
        if (typeof segment !== 'string') {
            throw new TypeError('segment must be a string.');
        }
        this.user.segments.push(segment);
    };
    Activity.prototype.setUserSegments = function (segments) {
        this.assertIsInit();
        if (!Array.isArray(segments) || segments.some(function (x) { return typeof x !== 'string'; })) {
            throw new TypeError('segments must be an array of strings.');
        }
        this.user.segments = segments;
    };
    Activity.prototype.addUserTrait = function (trait, traitValue) {
        this.assertIsInit();
        if (typeof trait !== 'string' || typeof traitValue !== 'string') {
            throw new TypeError('trait and traitValue must be strings.');
        }
        this.user.traits[trait] = traitValue;
    };
    Activity.prototype.setUserTraits = function (traits) {
        this.assertIsInit();
        if (!validateSchema_1.default(__assign(__assign({}, this.sample), { user: { identities: {}, traits: traits } }))) {
            throw new TypeError('The provided traits do not match the required format.');
        }
        this.user.traits = traits;
    };
    Activity.prototype.clearUser = function () {
        this.assertIsInit();
        this.user = { identities: {}, segments: [], traits: {} };
        this.storage.removeItem('attraqtsessionid');
        this.initUser(this.storage);
    };
    Activity.prototype.optOut = function () {
        this.assertIsInit();
        this.hasOptedOut = true;
        this.storage.setItem('attraqtoptout', 'true');
    };
    Activity.prototype.optIn = function () {
        this.assertIsInit();
        this.hasOptedOut = false;
        this.storage.removeItem('attraqtoptout');
    };
    return Activity;
}());
exports.Activity = Activity;
var Region;
(function (Region) {
    Region["DEV"] = "dev";
    Region["EU"] = "eu";
    Region["AP1"] = "ap1";
    Region["AP2"] = "ap2";
})(Region = exports.Region || (exports.Region = {}));
//# sourceMappingURL=activity.js.map